import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { cn } from '../utils/cn';

const UploadZone = ({ onFileProcess }) => {
  const [isDragging, setIsDragging] = React.useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length) processFile(files[0]);
  };

  const handleInput = (e) => {
    const files = e.target.files;
    if (files.length) processFile(files[0]);
  };

  const processFile = (file) => {
    if (file.type !== 'text/csv' && !file.name.endsWith('.csv')) {
      alert('Please upload a CSV file.');
      return;
    }
    onFileProcess(file);
  };

  return (
    <div 
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={cn(
        "relative group cursor-pointer flex flex-col items-center justify-center w-full min-h-[16rem] sm:min-h-[20rem] rounded-2xl sm:rounded-[2.5rem] border-2 border-dashed transition-all duration-300 overflow-hidden",
        isDragging 
          ? "border-blue-500 bg-blue-50/10 scale-[1.01]" 
          : "border-slate-300 dark:border-slate-700 hover:border-blue-400 bg-slate-50 dark:bg-slate-900/50"
      )}
    >
      <input 
        type="file" 
        accept=".csv" 
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
        onChange={handleInput}
      />
      
      <div className="z-0 flex flex-col items-center text-center p-6 sm:p-10 space-y-4 sm:space-y-6">
        <div className={cn(
          "p-4 sm:p-6 rounded-full transition-all duration-300 shadow-sm",
          isDragging 
            ? "bg-blue-100 text-blue-600 scale-110" 
            : "bg-white dark:bg-slate-800 text-slate-400 dark:text-slate-500"
        )}>
          <SafeIcon icon={FiIcons.FiUploadCloud} className="w-8 h-8 sm:w-10 h-10" />
        </div>
        
        <div className="space-y-2">
          <h3 className="text-xl sm:text-2xl font-black text-slate-800 dark:text-slate-100 tracking-tight">
            {isDragging ? 'Drop keyword file' : 'Upload CSV Data'}
          </h3>
          <p className="text-sm sm:text-base text-slate-500 dark:text-slate-400 max-w-sm mx-auto font-medium">
            Drag & drop or click to browse. Supports SEMrush, Ahrefs, or custom exports.
          </p>
        </div>
        
        <div className="flex items-center gap-3 px-4 py-2 bg-slate-200/50 dark:bg-slate-800 rounded-full">
           <div className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
           <span className="text-[10px] sm:text-xs font-black uppercase tracking-widest text-slate-500">Fast Cloud Processing</span>
        </div>
      </div>
    </div>
  );
};

export default UploadZone;